import { render, staticRenderFns } from "./mergeDialog.vue?vue&type=template&id=027a0614&scoped=true"
import script from "./mergeDialog.vue?vue&type=script&lang=js"
export * from "./mergeDialog.vue?vue&type=script&lang=js"
import style0 from "./mergeDialog.vue?vue&type=style&index=0&id=027a0614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027a0614",
  null
  
)

export default component.exports